import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    console.log('🔥 Turnstile controller connected:', this.identifier)

    const tryRender = () => {
      if (window.turnstile && window.turnstile.render) {
        console.log("🔥 Turnstile ready → rendering")
        this.replaceWidget()
        return
      }
      setTimeout(tryRender, 50)
    }

    tryRender()
  }

  replaceWidget() {
    const container = this.element

    // Remove previous widgets
    while (container.firstChild) {
      container.removeChild(container.firstChild)
    }

    // Render new widget
    window.turnstile.render(container, {
      sitekey: container.dataset.sitekey,
      theme: container.dataset.theme,
      size: container.dataset.size,
      action: container.dataset.action,
    })
  }
}
